import styles from './Whitening.module.scss';
import whiteningImg from '../../../shared/assets/photo/estetic/whitening.png';
import whiteningImg_2x from '../../../shared/assets/photo/estetic/whitening_2x.png';
import { Stack } from '../../../shared/ui/Stack/Stack';
import { Text } from '../../../shared/ui/Text/Text';

const Whitening = () => {
    return ( 
        <div>
        <div className={styles.container}>
            <div className={styles.whiteningImg}>
                <img className={styles.picture} src={whiteningImg}
                        srcSet={`${whiteningImg_2x} 2x`} alt="отбеливание" />
            </div>
            <Stack
                    direction = 'column'
                    gap = '32'
                    justifyContent='justifyCenter'
                    alignItems ='alignCenter'
                    className={styles.content}>
                <Text
                    size ='m'
                    className={styles.title}>
                        Процесс отбеливания зубов в нашей клинике
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        начинается с комплексной консультации для оценки состояния полости рта 
                        и обсуждения желаемого результата, а также противопоказаний
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        Мы предлагаем несколько видов отбеливания:
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        <span  className={styles.par}>Opalescence</span> – в эту систему входят отбеливающие гели для 
                        клинического и домашнего использования. Для проведения 
                        процедуры в клинике врач смешивает два отдельных компонента 
                        геля и  наносит его на зубы шприцом-дозатором, применяя 
                        специальные накладки, защищающие слизистую оболочку ротовой 
                        полости от возможных повреждений. Для зубов, при правильном 
                        применении, он совершенно безвреден. Это довольно мощный метод, 
                        и может использоваться только в кабинете стоматолога.
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        В домашних условиях используются силиконовые капы, которые 
                        изготавливаются индивидуально, для более точной и удобной посадки. 
                        Вы наносите предписанный гель на капы и носите их в течение определенного 
                        периода.
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        <span  className={styles.par}>Отбеливание зубов Zoom 4</span> - это система профессионального 
                        отбеливания от компании Philips. <br/>
                        В основе технологии Zoom лежит применение геля с высоким 
                        содержанием перекиси водорода -25% и воздействии на него
                        ультрафиолетового излучения, при котором выделяется активный 
                        кислород и разрушаются пигменты эмали. Гель также содержит 
                        фосфат кальция, который замещает собой пустоты, оставшиеся 
                        после разрушения пигмента, тем самым укрепляя эмаль. 
                        Лампа для отбеливания ZOOM имеет гибкую систему настроек и не 
                        перегревает зубную эмаль.
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        На завершающем этапе зубы покрывают реминерализирующим гелем для 
                        восстановления эмали и снижения чувствительности зубов.
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        Процедура отбеливания по данной технологии занимает в среднем 45 минут и отбеливает зубы в среднем  на 8 – 10 тонов. Результат после осветления 
                        зубной эмали может сохраняться до 3 лет при условии выполнения рекомендаций врача.
                </Text>               
            </Stack>
           
        </div>
        <div className={styles.precautionsContent}>
            <Stack
                direction = 'column'
                gap = '16'
                justifyContent='justifyCenter'
                alignItems ='alignCenter'
                className={styles.container}>
                <Text
                    size ='m'
                    className={styles.title}>
                        Противопоказания к отбеливанию:     
                </Text>
                <Text
                    size ='m'
                    className={styles.precautions}>
                        Возраст до 16 лет;
                </Text>
                <Text
                    size ='m'
                    className={styles.precautions}>
                        Беременность и период лактации;
                </Text>
                <Text
                    size ='m'
                    className={styles.precautions}>
                        Возможные аллергические реакции;
                </Text>
                <Text
                    size ='m'
                    className={styles.precautions}>
                        Кариес и пульпит;
                </Text>
                <Text
                    size ='m'
                    className={styles.precautions}>
                        Прием препаратов, увеличивающих восприимчивость эмали к ультрафиолетовому излучению;
                </Text>
                <Text
                    size ='m'
                    className={styles.precautions}>
                        Онкология
                </Text>
            </Stack>
            </div>
        </div>
    );
}
export default Whitening;